import { environment } from '../../../environments/environment';
import { SentryLogger } from './Sentry';
import { SessionStackLogger } from './SessionStack';
if (['stage', 'production'].includes(environment.name)) {
  SentryLogger.init();
  SessionStackLogger.init();
}
